import React from "react";

const industries = [
    {
        icon: "bi-bank",
        title: "Government",
        description:
            "Empowering public institutions with secure digital platforms, ERP systems, and workflow automation.",
        services: [
            "ERP Solutions",
            "Document Management",
            "Digital Transformation",
        ],
    },
    {
        icon: "bi-heart-pulse-fill",
        title: "Healthcare",
        description:
            "Modern healthcare systems that improve patient care, records management, and operational efficiency.",
        services: [
            "Hospital Systems",
            "Patient Records",
            "Appointments",
        ],
    },
    {
        icon: "bi-mortarboard-fill",
        title: "Education",
        description:
            "Helping institutions embrace digital learning and efficient academic management.",
        services: [
            "School Management",
            "Student Portals",
            "E-Learning",
        ],
    },
    {
        icon: "bi-shop",
        title: "Retail & Commerce",
        description:
            "Driving retail success through inventory systems, POS solutions, and eCommerce platforms.",
        services: [
            "POS Systems",
            "Inventory",
            "E-Commerce",
        ],
    },
    {
        icon: "bi-building-gear",
        title: "Manufacturing",
        description:
            "Enterprise solutions that streamline production, procurement, and inventory management.",
        services: [
            "SAP Business One",
            "Production",
            "Supply Chain",
        ],
    },
    {
        icon: "bi-cash-stack",
        title: "Finance",
        description:
            "Secure financial systems that enhance compliance, reporting, and customer experience.",
        services: [
            "Financial Systems",
            "Reporting",
            "Automation",
        ],
    },
    {
        icon: "bi-tree-fill",
        title: "Agriculture",
        description:
            "Innovative digital platforms that connect farmers, markets, and agricultural services.",
        services: [
            "Farm Management",
            "Weather",
            "Market Information",
        ],
    },
    {
        icon: "bi-truck",
        title: "Logistics",
        description:
            "Fleet, warehouse, and transport management solutions for modern logistics businesses.",
        services: [
            "Fleet Tracking",
            "Warehouse",
            "Route Planning",
        ],
    },
];

const IndustryCard = ({ industry, delay }) => (
    <div
        data-aos="fade-up"
        data-aos-delay={delay}
        className="group relative overflow-hidden rounded-3xl border border-slate-800 bg-slate-900/60 backdrop-blur-xl p-8 transition-all duration-500 hover:-translate-y-3 hover:border-amber-500/40 hover:shadow-[0_20px_60px_rgba(245,158,11,0.18)]"
    >
        {/* Glow */}
        <div className="absolute -top-20 -right-20 w-44 h-44 rounded-full bg-amber-500/10 blur-3xl opacity-0 group-hover:opacity-100 transition duration-700"></div>

        <div className="relative z-10">

            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-amber-500/5 flex items-center justify-center text-amber-400 text-3xl mb-6">
                <i className={`bi ${industry.icon}`}></i>
            </div>

            <h3 className="text-2xl font-bold text-white mb-4">
                {industry.title}
            </h3>

            <p className="text-slate-400 leading-7 mb-6">
                {industry.description}
            </p>

            <ul className="space-y-3">
                {industry.services.map((service) => (
                    <li
                        key={service}
                        className="flex items-center gap-3 text-slate-300"
                    >
                        <i className="bi bi-check-circle-fill text-amber-400"></i>
                        {service}
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default function Industries() {
    return (
        <section
            id="industries"
            className="relative py-28 bg-gradient-to-b from-[#050816] via-[#07111f] to-[#050816] overflow-hidden"
        >
            {/* Background Glow */}
            <div className="absolute -top-48 left-0 w-[500px] h-[500px] rounded-full bg-blue-600/10 blur-[180px]" />

            <div className="absolute bottom-0 right-0 w-[450px] h-[450px] rounded-full bg-amber-500/10 blur-[180px]" />

            <div className="max-w-7xl mx-auto px-6 relative z-10">

                {/* Header */}

                <div className="text-center max-w-3xl mx-auto">

                    <span className="inline-flex items-center gap-2 text-amber-400 uppercase tracking-[4px] text-sm font-semibold">
                        <span className="w-8 h-[1px] bg-amber-500"></span>
                        Industries We Serve
                        <span className="w-8 h-[1px] bg-amber-500"></span>
                    </span>

                    <h2 className="mt-6 text-5xl md:text-6xl font-black text-white leading-tight">
                        Delivering Solutions Across
                        <span className="block bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">
                            Multiple Industries
                        </span>
                    </h2>

                    <p className="mt-6 text-lg text-slate-400 leading-8">
                        We partner with organizations across diverse sectors,
                        delivering secure, scalable, and innovative digital
                        solutions that improve efficiency, drive growth, and
                        accelerate digital transformation.
                    </p>

                </div>

                {/* Grid */}

                <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8 mt-20">
                    {industries.map((industry, index) => (
                        <IndustryCard
                            key={industry.title}
                            industry={industry}
                            delay={index * 100}
                        />
                    ))}
                </div>

                {/* Bottom CTA */}

                <div className="mt-20 text-center">

                    <p className="text-slate-300 text-lg mb-8">
                        Don't see your industry? We build custom solutions for
                        businesses of all sizes.
                    </p>

                    <a
                        href="#contact"
                        className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold transition-all duration-300 hover:scale-105"
                    >
                        Request a Consultation
                        <i className="bi bi-arrow-right"></i>
                    </a>

                </div>

            </div>
        </section>
    );
}